import React from 'react'
import List, { ListProps } from './List'
import { PortalType, SlotPortal } from '../Portal'
import Breadcrumbs from '../Breadcrumbs'
import ListTabs from './ListTabs'
import Pagination from '../Pagination'
import styles from '../../../CSS/main.css'
import classNames from 'classnames'
import { Col } from './Col'
import SearchBox from '../Search/SearchBox'
import Page from '../Page'
import { Tab } from '../Filters/types'
import { SpinnerDotted } from 'spinners-react'
import Spinner from '../Spinner'

type Props = {
  readonly title: string
  readonly onBack: () => void
  readonly tabs: ReadonlyArray<Tab>
  readonly activeTab: string
  readonly onChangeTab: (tab: string) => void
  readonly pageCount: number
  readonly page: number
  readonly onPageChange: (page: number) => void
  readonly searchTerm: string
  readonly onChangeSearch: (newTerm: string) => void
  readonly filters: (onClose: () => void) => JSX.Element
  readonly breadcrumbActions?: React.ReactNodeArray
  readonly loading: boolean
  readonly onSearch?: (keyword: string) => void
  readonly isResetSearch?: boolean
  readonly isShowSearch?: boolean
  readonly commentCount?: number
  readonly searchType?: string
  readonly dataSelectedCount?: number
}

const ListPage = <T,>({
  onBack,
  title,
  page,
  pageCount,
  onPageChange,
  tabs,
  activeTab,
  onChangeTab,
  filters,
  searchTerm,
  onChangeSearch,
  breadcrumbActions,
  loading,
  onSearch,
  isResetSearch,
  isShowSearch,
  commentCount,
  searchType,
  dataSelectedCount,
  ...listProps
}: ListProps<T> & Props): JSX.Element => {
  return (
    <Page>
      <SlotPortal name={PortalType.Toolbar}>
        <Breadcrumbs
          onBack={onBack}
          title={title}
          actionButtons={breadcrumbActions}
          onSearch={onSearch}
          isShowSearch={isShowSearch}
          searchType={searchType}
        />
        {isResetSearch && (
          <div className={classNames([styles.Table, styles.SearchTabs])}>
            <ListTabs
              tabs={tabs}
              activeTab={activeTab}
              onChangeTab={onChangeTab}
            />
            <Col>
              <SearchBox
                filters={filters}
                searchTerm={searchTerm}
                onChangeSearch={onChangeSearch}
              />
            </Col>
          </div>
        )}
        {!loading && Number.isInteger(commentCount) && (
          <div className={styles.CommentCount}>
            {dataSelectedCount > 0 ? (
              <div>
                {dataSelectedCount}{' '}
                {dataSelectedCount > 1 ? 'comments' : 'comment'} selected
              </div>
            ) : (
              <div />
            )}
            <div>
              {activeTab === 'all' ? (
                <>
                  {commentCount} {commentCount > 1 ? 'comments' : 'comment'}{' '}
                  total
                </>
              ) : (
                <>
                  {commentCount} {activeTab}{' '}
                  {commentCount > 1 ? 'comments' : 'comment'}
                </>
              )}
            </div>
          </div>
        )}
      </SlotPortal>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <List {...listProps} />
          <Pagination
            total={pageCount}
            page={page}
            onPageChange={onPageChange}
          />
        </>
      )}
    </Page>
  )
}

export default ListPage
